import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "memory" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-2"
}
const _hoisted_3 = { class: "memory-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "back" }
const _hoisted_6 = ["src"]

import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";

import {AppNetworkErrorOther, networkErrorText} from "@/crud"
import {TranslatedText} from "@/store/types";

import image1 from '@/assets/memory/1.jpg';
import image2 from '@/assets/memory/2.jpg';
import image3 from '@/assets/memory/3.jpg';
import image4 from '@/assets/memory/4.jpg';
import image5 from '@/assets/memory/5.jpg';
import image6 from '@/assets/memory/6.jpg';

type Card = {
  id: number;
  content: { url: string };
  isPairFound: boolean;
}

type FlippedCard = Card & { index: number};


export default /*@__PURE__*/_defineComponent({
  __name: 'Memory',
  setup(__props) {

let timer: number | undefined = undefined;

const faces = [
  {url: image1},
  {url: image2},
  {url: image3},
  {url: image4},
  {url: image5},
  {url: image6},
]

const turn  = ref(0);
const flippedCards = ref<FlippedCard[]>([]);
const deckOfCards = ref<Card[]>([]);
const cards = ref<Card[]>([]);
const allPairsAreFound = ref(false);

const isFlippedClass = ({id, isPairFound}) => {
  return {
    flipped: flippedCards.value.find((x) => x.id === id),
    matchingPair: isPairFound
  };
};

const onClick = (card: Card, index: number) => {
  if(flippedCards.value.find((x) => x.id === card.id)) {
    return;
  }

  if (!card.isPairFound) {
    clearTimeout(timer);
    flippedCards.value = flippedCards.value.length === 2
        ? [{...card, index}]
        : [...flippedCards.value, {...card, index}];
  }
};

const shuffle = (cards: Card[]) => {
  return cards.sort(() => Math.random() - 0.5);
};

const replay = () => {
  clearTimeout(timer);
  turn.value = 0;
  flippedCards.value = [];
  cards.value = cards.value.map((x) => {
    return {...x, isPairFound: false};
  });
  deckOfCards.value = shuffle(cards.value);
};

onMounted(() => {
  // Create all cards obj
  cards.value = faces.map((x, index) => {
    return {id: index, content: x, isPairFound: false};
  });

  // Dupplicate obj to get pairs and concat them to the existing array
  cards.value = cards.value.concat(
      cards.value.slice().map((card) => {
        return {
          ...card,
          id: cards.value.length + card.id,
        };
      })
  );

  deckOfCards.value = shuffle(cards.value);
});

watch(
    () => flippedCards.value,
    (cards) => {
      if (cards.length === 2) {
        turn.value++;
        if (cards[0].content === cards[1].content) {
          deckOfCards.value[cards[0].index].isPairFound = true;
          deckOfCards.value[cards[1].index].isPairFound = true;
        } else if (cards[0].content !== cards[1].content) {
          timer = setTimeout(
              () => flippedCards.value = [],
              2000
          );
        }
        allPairsAreFound.value = deckOfCards.value.every((x) => x.isPairFound);
      }
    }
);

// scoring logic

const store = useStore();

const score_reaction = computed(() => {
  return store.state.i.me.score_reaction;
});

const errorstring = ref<TranslatedText>({de: '', en: ''});

watch(
    () => allPairsAreFound.value,
    async (allPairsAreFound) => {
      if(allPairsAreFound) {
        await store.dispatch('i/setDataRankingE', 5);

        if (turn.value < score_reaction.value || score_reaction.value === 0) {
          try {
            errorstring.value = {de: '', en: ''}
            const dpr = await store.dispatch("i/setDataCompetition", {score_reaction: turn.value})
            if (!dpr.sv) {
              errorstring.value = {
                de: "Feld konnte nicht gesetzt werden.",
                en: "Could not set Field."
              }
            }
          } catch (e) {
            errorstring.value = networkErrorText(e as AppNetworkErrorOther)
          }
        }
      }
    }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", null, [
      _createElementVNode("h4", { class: "p-1" }, "Memory Game"),
      _createElementVNode("p", null, [
        _createTextVNode(" Click on the cards to find the matching pairs. By completing the memory game you will receive points to increase your online activity score!"),
        _createElementVNode("br"),
        _createTextVNode(" The highest online activity score win a ticket to #GMF26. ")
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("small", null, " Rules: Click on two cards to flip them over and find matching pairs of famous landmarks in North Rhine-Westphalia. The game will track your progress until you have found them all. Try to match all the pairs in the fewest possible turns to get the highest score! ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      (errorstring.value.de !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(store).getters.i18n(errorstring.value)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createTextVNode(" My best score: " + _toDisplayString(score_reaction.value > 0 ? `${score_reaction.value} Attempts` : '-') + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" Turn: " + _toDisplayString(turn.value), 1)
      ]),
      (allPairsAreFound.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary btn-lg",
            onClick: replay
          }, "Play again"))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deckOfCards.value, (card, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (onClick(card, index)),
            class: _normalizeClass(['memory-card', isFlippedClass(card)]),
            key: card.id
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "front" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: card.content.url,
                alt: "Card"
              }, null, 8, _hoisted_6)
            ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ], 64))
}
}

})